module.exports = __webpack_public_path__ + "img/logocapSur.f2830a18.png";